export const RECORDING_STUDIO_PATH = '/recording-studio'

/**
 * 세뇨 녹음실은 새로고침 후에도 현재 화면을 복구할 수 있어야 하므로
 * React view state만 사용하지 않고 안정적인 URL 경로를 함께 사용합니다.
 */
export function isRecordingStudioPath(pathname: string): boolean {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  return normalized === RECORDING_STUDIO_PATH
}
